import React, { useEffect, useState } from "react";
import { FiWifiOff, FiWifi } from "react-icons/fi";
import "./index.css";

/**
 * Thin bar at the top of every page while the device has no internet,
 * and a short "Back online" message when it returns.
 */
const OfflineBanner = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  const [backOnline, setBackOnline] = useState(false);

  useEffect(() => {
    let timer;
    const goOffline = () => { setOffline(true); setBackOnline(false); };
    const goOnline = () => {
      setOffline(false);
      setBackOnline(true);
      clearTimeout(timer);
      timer = setTimeout(() => setBackOnline(false), 3000);
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
      clearTimeout(timer);
    };
  }, []);

  if (!offline && !backOnline) return null;

  return (
    <div className={`offline-banner ${offline ? "is-offline" : "is-online"}`} role="status" aria-live="polite">
      {offline ? <FiWifiOff aria-hidden="true" /> : <FiWifi aria-hidden="true" />}
      <span>
        {offline
          ? "You're offline. Check your internet connection — data on this page may be out of date."
          : "Back online. Use Refresh / Try again to load the latest data."}
      </span>
    </div>
  );
};

export default OfflineBanner;
